import React, { useRef } from 'react';

/**
 * make google gods happy
 * @constructor
 */
export default function PrequalPlacesAttribution() {
  const ref = useRef(null);
  return <div data-testid="prequal-places-attribution" id="prequal-places-attribution" ref={ref} />;
}
